import React, { Component } from 'react';
import { Button, Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import Image from '../../../assets/img/login/login-bg.jpg';
import Logo from '../../../assets/img/login/q-radar_logo.png';
import '../../../css/login/login.css';
import queryString from 'query-string';
import AxiosInstance from '../../../components/AxiosInstance/AxiosInstance';



const styles = {
  header: {
    backgroundImage: `url(${Image})`,
    height: '100vh',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },

  content: {
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'white'
  }
}

class ResetForgetPassword extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: new Array(19).fill(false),
      fields: {},
      errors: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.resetFrgPass = this.resetFrgPass.bind(this);
  }

  handleChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });
  }

  validateForm() {

    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "*This field is mandatory.";

    }

    if (!fields["confirmPassword"]) {
      formIsValid = false;
      errors["confirmPassword"] = "*This field is mandatory.";
    }


    if (fields["confirmPassword"] != fields["password"]) {
      formIsValid = false;
      errors["confirmPassword"] = "Password doesn't match";
      errors["password"] = "Password doesn't match";
    }
    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  resetFrgPass(e) {
    e.preventDefault();
    if (this.validateForm()) {

      let userId = this.props.match.params.userId;
      let url = this.props.location.search;
      let params = queryString.parse(url);
      
      AxiosInstance({
        method: "post",
        url: "tbSYS_m_User/usp_tbSYS_m_User_ResetPwd",
        data: {
          tbSYSmUserID: 0,
          ResetKey: params.key,
          sUserPwd: this.state.fields.password,
          auditScreen: "RESETPASSWORDFROMLOGINSCREEN",
          auditPage: "resetPassword",
          dctbSYSmUserID: 0,
          sLoginID: "",
        }
      }).then(response => {
        if (response.data === "true") {
          window.location.hash = '#/login';
        }
        else {
          alert("Reset Password fail");
        }
       }).catch(function (error) {
     });
    }
  }

  componentDidMount() {
    let url = this.props.location.search;
    let params = queryString.parse(url);

    AxiosInstance({
      method: "post",
      url: "tbSYS_m_User/usp_tbSYS_m_User_SelectByResetKey",
      data: {
        tbSYSmUserID: 0,
        ResetKey: params.key
      }
    }).then(response => {
      if (response.data != "") {
        alert("Reset Password Expired");
        window.location.hash = "#/login";
      }
      }).catch(function (error) {

      });
  }



  render() {
    return (

      <div>
        <div style={styles.header}>
          <div style={styles.content}>
            <div className="app flex-row align-items-center">
              <Container>
                <Row className="justify-content-center">
                  <Col md="9">
                    <CardGroup>
                      <Card className="p-2">
                        <CardBody>
                          <Form method="post" name="resetForgetPassword" onSubmit={this.resetFrgPass} >
                            <Row className="text-center">
                              <Col >
                                <div className="logo" >
                                  <img src={Logo} width="110" height="120" alt="" />
                                </div>
                              </Col>
                            </Row>

                            <p className="text-muted">Please create your new password</p>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="icon-lock"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input type="password" placeholder="New Password" value={this.state.fields.password || ''} onChange={this.handleChange} name="password" />
                            </InputGroup>
                            <Row >
                              <Col>
                                <div className="errorMsg" >{this.state.errors.password}</div>
                              </Col>
                            </Row>
                            <InputGroup className="mb-4">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="icon-lock"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input type="password" placeholder="Confirm Password" value={this.state.fields.confirmPassword || ''} onChange={this.handleChange} name="confirmPassword" />
                            </InputGroup>
                            <Row>
                              <Col>
                                <div className="errorMsg">{this.state.errors.confirmPassword}</div>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="text-right">
                                <Button color="primary" className="px-4" value="Register" >Confirm Password</Button>
                              </Col>
                            </Row>
                          </Form>
                          <Row>
                            <Col>
                              <p className="text-muted" style={{ fontSize: '80%' }} >
                                Version 10.030.100 <br />
                                2018 Copyright © by Tricor Roots Consulting (471614-P). All rights reserved
                              </p>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </CardGroup>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ResetForgetPassword;
